const timeToMilliseconds = (timeStr: string) => {
    const [time, period] = timeStr.split(/(?=[ap]m)/);
    // eslint-disable-next-line prefer-const
    let [hours, minutes] = time.split(':').map(Number);
    if (period === 'pm' && hours !== 12) {
        hours += 12;
    } else if (period === 'am' && hours === 12) {
        hours = 0;
    }
    return hours * 3600000 + minutes * 60000;
};

export const sortByTime = (list: { time: string }[]) => {
    return list.sort((a, b) => timeToMilliseconds(a.time) - timeToMilliseconds(b.time));
};
